import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup, NgForm, Validators} from '@angular/forms';
import {AuthService} from '../../core/auth/auth.service';
import {Router} from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserService } from '../../core/user.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css']
})
export class LoginPageComponent implements OnInit {
    loginForm : FormGroup=new FormGroup({
        email:new FormControl(null,[Validators.email,Validators.required]),
        password:new FormControl(null, Validators.required)
    });
    hostUrl;
    constructor(private authService: AuthService, private router: Router, private http:HttpClient, private userService: UserService ) { }

    ngOnInit() {
        this.hostUrl=this.userService.getUrl();
    }

    moveToRegister(){
        this.router.navigate(['/register']);
    }


    login(){
        let userQuery;
        let userRole=99;
        let userId;
        let token;
        let status;
        if(!this.loginForm.valid){
            
            swal({
                type:'error',
                width: 300,
                text:'Unauthorized User',
                showConfirmButton: false,                   
                timer: 1500
          })
          this.router.navigate(['/register']);
            return;
            
        }
        
        this.authService.login(JSON.stringify(this.loginForm.value))
            .subscribe(
                data=>{
                    token = data['token']
                    userRole = data['userRole'];
                    userId = data['user_id']; 
                    status = data['status'];                   
                    this.authService.loggedIn();    
                    localStorage.setItem('userid', userId);
                    localStorage.setItem('token', token);         
              
                    //Check if user is Project Manager as well as Portfolio Manager ( 2 roles )
                        this.http.get(encodeURI(this.hostUrl+'/api/issue/loginRole/'+userId))      
                        .subscribe((data) => {

                        
                    
                        if(data[0]){
                            localStorage.setItem('CurrentRole', '2');
                            this.router.navigate(['/ah']);
                                swal({
                                type:'success',
                                width: 300,
                                text:'Login successfull!',
                                showConfirmButton: false,                   
                                timer: 1500
                          })
                        }
                        
                        else{
                             //Super Admin
                         if(userRole==1){          
                            localStorage.setItem('CurrentRole', '1');  
                             this.router.navigate(['/su']);
                             swal({
                                type:'success',
                                width: 300,
                                text:'Login successfull!',
                                showConfirmButton: false,                   
                                timer: 1500
                          })
                             
                         }
                         else
                         //Portfolio Manager
                         if(userRole==2){
                            localStorage.setItem('CurrentRole', '2');
                             this.router.navigate(['/ah']);
                             swal({
                                type:'success',
                                width: 300,
                                text:'Login successfull!',
                                showConfirmButton: false,                   
                                timer: 1500
                          })
                         }
                         else 
                         if(userRole==3){
                            localStorage.setItem('CurrentRole', '3');
                             this.router.navigate(['/qab']);
                             swal({
                                type:'success',
                                width: 300,
                                text:'Login successfull!',
                                showConfirmButton: false,                   
                                timer: 1500
                          })
                             
                         }
                         else
                         if(userRole==4){
                            localStorage.setItem('CurrentRole', '4');
                             this.router.navigate(['/home']);
                             swal({
                                type:'success',
                                width: 300,
                                text:'Login successfull!',
                                showConfirmButton: false,                   
                                timer: 1500
                          })
                             
                         }
                         else
                         if(userRole==5){
                            localStorage.setItem('CurrentRole', '5');
                             this.router.navigate(['/home']);
                             swal({
                                type:'success',
                                width: 300,
                                text:'Login successfull!',
                                showConfirmButton: false,                   
                                timer: 1500
                          })

                         }else
                         if(userRole==6){
                            localStorage.setItem('CurrentRole', '6');
                             this.router.navigate(['/home']);
                             swal({
                                type:'success',
                                width: 300,
                                text:'Login successfull!',
                                showConfirmButton: false,                   
                                timer: 1500
                          })
                         }
                         else
                         if(userRole==0){
                             alert("No Role Assigned");
                         }
                         else
                        {  
                            swal({
                                type:'error',
                                width: 300,
                                text:'User is inactive',
                                showConfirmButton: false,                   
                                timer: 1500
                          })
                         // this.router.navigate(['/register']);
                        }
                        } 
                          
                                                        
                    }); 
                              
                    } ,
                   
                
                    error => alert("Something Went Wrong!!!!")
                
            );
               
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/login-page/login-page.component.ts